"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkIfAnyUserLoggedIn = checkIfAnyUserLoggedIn;
exports.clearPreviousMessage = clearPreviousMessage;
exports.complain = complain;
exports.mention = mention;
var _solidUi = require("solid-ui");
var _errorDisplay = require("./utils/errorDisplay");
function complain(buttonContainer, context, error) {
  const errorBlock = _solidUi.widgets.errorMessageBlock(context.dom, (0, _errorDisplay.formatDisplayError)(error));
  errorBlock.setAttribute('role', 'alert');
  errorBlock.setAttribute('aria-live', 'assertive');
  errorBlock.setAttribute('tabindex', '0');

  // Focus the error message for screen readers
  setTimeout(() => {
    errorBlock.focus();
  }, 100);
  buttonContainer.appendChild(errorBlock);
}
function mention(buttonContainer, message) {
  const positiveFrontendMessageDiv = document.createElement('div');
  positiveFrontendMessageDiv.setAttribute('role', 'status');
  positiveFrontendMessageDiv.setAttribute('aria-live', 'polite');
  positiveFrontendMessageDiv.setAttribute('tabindex', '0');
  positiveFrontendMessageDiv.classList.add('profile__action-button', 'licOkay');
  positiveFrontendMessageDiv.innerHTML = message;

  // Focus the success message for screen readers
  setTimeout(() => {
    positiveFrontendMessageDiv.focus();
  }, 100);
  buttonContainer.appendChild(positiveFrontendMessageDiv);
}
function clearPreviousMessage(buttonContainer) {
  while (buttonContainer.childNodes.length > 2) {
    buttonContainer.removeChild(buttonContainer.lastChild);
  }
}
function checkIfAnyUserLoggedIn(me) {
  if (me) return true;else return false;
}